import { useEffect } from "react"

import { useResponsive } from "../../providers"

import Layout from "./Layout"

const Main = (props) => {
  const { isShownSidebarMobile, setIsShownSidebarMobile, isMobile } = useResponsive()

  const handler = () => setIsShownSidebarMobile(!isShownSidebarMobile)

  const layoutProps = {
    ...props,
    handler,
    isMobile,
    isShownSidebarMobile: isShownSidebarMobile,
  }

  return <Layout {...layoutProps} />
}

export default Main
